<template>
  <div>
    <v-icon v-if="connected" class="mt-1 ml-1" color="success">mdi-ear-hearing</v-icon>
    <v-icon v-else class="mt-1 ml-1" color="error">mdi-ear-hearing-off</v-icon>
    <v-container class="llamadas-placeholder" v-if="estilo.type === 'LlamadasPlaceHolder'">
      <v-row no-gutters>
        <v-col lg="7">
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="display-2 font-weight-bold text-center header-call"
                :class="{'blink': calling}"
              >{{ lastCall }}</div>
              <v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <div class="container" v-if="selectedMedia == 'images' && mediaContent != ''">
                <v-carousel
                  :show-arrows="false"
                  hide-delimiters
                  cycle
                  interval="10000"
                >
                  <v-carousel-item
                    v-for="(item,i) in mediaContent"
                    :key="i"
                    :src="`${apiUrl}/${item}`"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                    contain
                  ></v-carousel-item>
                </v-carousel>
              </div>
              <div id="video-container" class="container" v-else-if="selectedMedia == 'youTubeUrl'">
                <div v-if="!mediaLoaded || !mediaContent" class="loading-container">
                  <div class="loading-text">Cargando video...</div>
                </div>
                <iframe
                  v-else-if="mediaContent !== '' && getYouTubeVideoId(mediaContent)"
                  ref="youtubeIframe"
                  :src="getYouTubeEmbedUrl(mediaContent)"
                  :width="videoWidth"
                  :height="videoHeight"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
                <div v-else class="error-container">
                  <div class="error-text">Error: No se pudo cargar el video de YouTube</div>
                </div>
              </div>
              <div id="video-container" class="container" v-else-if="selectedMedia == 'video'">
                <video
                  v-if="mediaContent !== ''"
                  :src="`${apiUrl}/${mediaContent}`"
                  controls
                  loop
                  autoplay
                  muted
                  :style="{ width: videoWidth + 'px' , height: videoHeight + 'px' }"
                >Your browser does not support the video tag.</video>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col lg="5">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="display-1 font-regular header-grid">Últimas llamadas</div>
              <v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>
          <v-list-item three-line>
            <v-list-item-content>
              <v-card v-show="calling" class="center" outlined>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="display-3 font-weight-bold text-center blink">{{ callingWho }}</div>
                    <v-divider class="my-5"></v-divider>
                    <div class="display-2 font-weight-bold text-center blink">{{ callingWhere }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
              <v-simple-table v-show="!calling">
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item, index) in llamadasRecepcion" :key="index">
                      <td
                        class="who last-calls text-left"
                        :class="{'display-2':!item.showPatient, 'display-1':item.showPatient}"
                      >{{ item.quien }}</td>
                      <td class="where text-left display-2">{{ item.donde }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="llamadas-simple">
      <v-app>
        <v-card v-show="calling" class="center" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="display-10 font-weight-bold text-center blink">{{ callingWho }}</div>
              <v-divider class="my-5"></v-divider>
              <div class="display-8 font-regular text-center blink">{{ callingWhere }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-simple-table v-show="!calling">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="who text-left">{{ getMessage('TTL_LLAMADAS_NUMERO') }}</th>
                <th class="where text-left">{{ getMessage('TTL_LLAMADAS_PUESTO') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in llamadasRecepcion" :key="index">
                <td class="who text-left">{{ item.quien }}</td>
                <td class="where text-left">{{ item.donde }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-app>
    </v-container>
  </div>
</template>
<script>
import { LogLevel, HubConnectionBuilder } from '@microsoft/signalr'
import { mapActions, mapState, mapGetters } from 'vuex'
import getAPIUrl from '@/helpers/getAPIUrl'

export default {
  computed: {
    ...mapState('Llamadas', ['llamadasRecepcion']),
    ...mapState('InitConfig', ['media']),
    ...mapGetters('GeneralAR', ['getMessage']),
    ...mapGetters('InitConfig', [
      'getEstilo',
      'getSalaActual',
      'getTipo',
      'getSelectedMedia',
      'getParametrosGeneralesAmb'
    ]),
    connectionState: function () {
      if (this.connection !== null) {
        return this.connection.state
      }
      return ''
    },
    connected: function () {
      return this.isConnected()
    },
    tipoLlamador: function () {
      if (this.estilo.type === 'LlamadasPlaceHolder') {
        return 2
      } else {
        return 1
      }
    }
  },
  data () {
    return {
      connection: null,
      lastCall: '',
      calling: false,
      callingWho: '',
      callingWhere: '',
      salaActual: {},
      callingTime: 5000,
      tipo: {},
      estilo: {},
      selectedMedia: 0,
      apiUrl: '',
      audio: null,
      queue: [],
      mediaContent: '',
      youtubeWidth: 200,
      youtubeHeight: 200,
      mediaLoaded: false,
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin',
        'fab fa-instagram'
      ]
    }
  },
  destroyed () {
    this.connection.stop()
  },
  async mounted () {
    this.apiUrl = await getAPIUrl()
    this.salaActual = this.getSalaActual()
    this.estilo = this.getEstilo()
    this.tipo = this.getTipo()
    this.setMedia(this.estilo.type !== 'LlamadasPlaceHolder')
    this.fetchLlamadas()
    this.recursiveCall()
    await this.connectSignalR()
  },
  methods: {
    ...mapActions('Llamadas', ['fetchLlamadasRecepcion', 'fetchLlamadasConsultorio']),
    ...mapActions('InitConfig', ['fetchMedia']),
    joinSignalRGroup () {
      var vm = this
      vm.connection.invoke('AddToGroup', vm.salaActual.salaId.toString())
        .then(result => {
          // eslint-disable-next-line no-console
          console.log('Grupo unido con éxito, resultado:', result, 'salaId:', vm.salaActual.salaId.toString())
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error('Error al unirse al grupo:', err)
        })

      vm.connection.on('Joined', msg => {
        // eslint-disable-next-line no-console
        console.log('on Joined:', msg)
      })

      vm.connection.on('GroupJoinError', errMsg => {
        // eslint-disable-next-line no-console
        console.error('Error desde el servidor al unirse al grupo:', errMsg)
      })
    },
    fetchLlamadas () {
      var params = {
        salaId: this.salaActual.salaId,
        tipoLlamador: this.tipoLlamador
      }
      if (this.tipo.id === 1) {
        this.fetchLlamadasRecepcion(params)
      } else {
        this.fetchLlamadasConsultorio(params)
      }
    },
    listenSignalREvents () {
      var vm = this
      var signalREvent = this.tipo.id === 1 ? 'ReceiveNewLlamadaRecepcion' : 'ReceiveNewLlamadaConsultorio'
      vm.connection.on(signalREvent, data => {
        vm.queue.push(data)
        vm.fetchLlamadas()
      })
      vm.connection.on('RefreshScreen', data => {
        window.location.reload(true)
      })
    },
    async connectSignalR () {
      var vm = this
      vm.connection = new HubConnectionBuilder()
        .withUrl(`${vm.apiUrl}/llamadasHub`)
        .configureLogging(LogLevel.Information) // Cambiar de Debug a Information para producción
        .withAutomaticReconnect([
          0, // reconexión inmediata
          2000, // 2 segundos
          5000, // 5 segundos
          10000, // 10 segundos
          30000, // 30 segundos
          60000 // 60 segundos - máximo, sin null para evitar loop infinito
        ])
        .build()

      vm.connection.start().then(function () {
        vm.joinSignalRGroup()
        vm.listenSignalREvents()
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error('Error al conectar SignalR:', err)
      })

      vm.connection.onreconnected(connectionId => {
        // eslint-disable-next-line no-console
        console.log('SignalR reconectado exitosamente:', connectionId)
        vm.joinSignalRGroup()
      })

      // Manejar fallas de reconexión
      vm.connection.onreconnecting(error => {
        // eslint-disable-next-line no-console
        console.warn('SignalR intentando reconectar...', error)
      })

      // Manejar cuando se agoten los intentos de reconexión
      vm.connection.onclose(error => {
        if (error) {
          // eslint-disable-next-line no-console
          console.error('SignalR desconectado con error:', error)
        } else {
          // eslint-disable-next-line no-console
          console.log('SignalR desconectado normalmente')
        }
      })
    },
    isConnected () {
      return this.connectionState.toLowerCase().trim() === 'connected'
    },
    recursiveCall () {
      var vm = this
      setInterval(() => {
        var numberToCall = vm.queue.shift()
        if (typeof numberToCall !== 'undefined') {
          vm.call(numberToCall.quien, numberToCall.donde)
        }
      }, vm.callingTime + 500)
    },
    call (quien, donde) {
      var vm = this
      vm.lastCall = `${quien} ${vm.getMessage(
        'TXT_LLAMADAS_SEPARADOR_QUIEN_DONDE'
      )} ${donde}`
      vm.callingWho = quien
      vm.callingWhere = donde
      vm.calling = true
      setTimeout(() => {
        vm.calling = false
      }, vm.callingTime)
      vm.playSound()
      if (vm.getParametrosGeneralesAmb.llamarPacientesPorAudio) {
        setTimeout(() => {
          vm.llamadaPorAltaVoz(quien, donde)
        }, 3000)
      }
    },
    playSound () {
      this.audio.crossOrigin = 'anonymous'
      this.audio.play()
    },
    llamadaPorAltaVoz (quien, donde) {
      var msg = new SpeechSynthesisUtterance()
      msg.rate = 1
      msg.text = `${quien}, ..... ${donde}`
      window.speechSynthesis.speak(msg)
    },
    setMedia (onlyAudio) {
      var vm = this
      this.selectedMedia = this.getSelectedMedia()
      this.mediaLoaded = false // Reset loading state

      vm.fetchMedia().then(() => {
        vm.audio = new Audio(`${vm.apiUrl}/${vm.media.audio}`)
        if (!onlyAudio) {
          if (
            vm.selectedMedia === 'youTubeUrl' ||
            vm.selectedMedia === 'video'
          ) {
            // Usar setTimeout para asegurar que el DOM está listo
            setTimeout(() => {
              const container = document.getElementById('video-container')
              if (container) {
                vm.videoWidth = container.offsetWidth < 200 ? 200 : container.offsetWidth
                vm.videoHeight = container.offsetHeight < 200 ? 200 : container.offsetHeight
              } else {
                vm.videoWidth = 400 // Default fallback
                vm.videoHeight = 300
              }

              vm.mediaContent = vm.media[vm.selectedMedia]

              // Validar contenido de YouTube antes de marcar como cargado
              if (vm.selectedMedia === 'youTubeUrl') {
                if (vm.getYouTubeVideoId(vm.mediaContent)) {
                  vm.mediaLoaded = true
                } else {
                  vm.mediaLoaded = false
                }
              } else {
                vm.mediaLoaded = true
              }
            }, 100)
          } else {
            vm.mediaContent = vm.media[vm.selectedMedia]
            vm.mediaLoaded = true
          }
        } else {
          vm.mediaLoaded = true
        }
      }).catch(() => {
        // Error loading media - set loading state to false
        vm.mediaLoaded = false
      })
    },
    getYouTubeVideoId (url) {
      if (!url) {
        return null
      }

      // Si ya es solo el ID del video (11 caracteres), retornarlo directamente
      if (url.match(/^[a-zA-Z0-9_-]{11}$/)) {
        return url
      }
      // Expresiones regulares para diferentes formatos de URL de YouTube
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      if (match && match[2].length === 11) {
        return match[2]
      }
      // Si no se puede extraer el ID, retornar null
      return null
    },
    getYouTubeEmbedUrl (url) {
      const videoId = this.getYouTubeVideoId(url)
      if (!videoId) {
        return null
      }

      // Crear URL embed con parámetros para autoplay, controles, etc.
      const embedUrl = `https://www.youtube.com/embed/${videoId}?` +
        'autoplay=1&' + // Autoplay activado
        'mute=1&' + // Muted para que autoplay funcione en navegadores modernos
        'controls=0&' + // Mostrar controles
        'loop=1&' + // Loop activado
        `playlist=${videoId}&` + // Necesario para que loop funcione
        'rel=0&' + // No mostrar videos relacionados
        'modestbranding=0&' + // Branding mínimo de YouTube
        'enablejsapi=1' // Habilitar JS API por si se necesita después

      return embedUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.llamadas-placeholder {
  tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  td.last-calls {
    height: 100px;
  }
  td.who {
    width: 65%;
  }
  td.where {
    width: 35%;
  }
  .container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 80%;
  }
  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .header-call {
    height: 100px;
    padding-top: 30px;
  }
  .header-grid {
    height: 100px;
    padding-top: 60px;
  }
  .loading-container,
  .error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 200px;
    background-color: #f5f5f5;
    border-radius: 8px;
  }
  .loading-text {
    font-size: 18px;
    color: #666;
    font-weight: 500;
  }
  .error-text {
    font-size: 16px;
    color: #d32f2f;
    font-weight: 500;
    text-align: center;
    padding: 0 20px;
  }
  .display-10 {
    font-size: 12px;
  }
  .display-8 {
    font-size: 10px;
  }
  .center {
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .blink {
    animation-name: parpadeo;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    -webkit-animation-name: parpadeo;
    -webkit-animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
  }

  @-moz-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
}
.llamadas-simple {
  .display-10 {
    font-size: 120px;
  }
  .display-8 {
    font-size: 100px;
  }
  tbody {
    tr {
      height: 100px !important;
      td {
        font-size: 2vw !important;
      }
    }
    tr:nth-child(3) {
      height: 110px !important;
      td {
        font-size: 2.3vw !important;
        font-weight: bold;
      }
    }
    tr:nth-child(2) {
      height: 120px !important;
      td {
        font-size: 2.5vw !important;
        font-weight: bold;
      }
    }
    tr:first-child {
      height: 130px !important;
      td {
        font-size: 3vw !important;
        font-weight: bold;
      }
    }
  }
  thead {
    tr {
      height: 70px !important;
      th {
        font-size: 2vw !important;
      }
      th.who {
        width: 70%;
      }
      th.where {
        width: 30%;
      }
    }
  }
  .center {
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .blink {
    animation-name: parpadeo;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    -webkit-animation-name: parpadeo;
    -webkit-animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
  }

  @-moz-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
